import {createSelector} from 'reselect';

import {getUIState} from '../../../ui-selectors';

const getWidgetOpensState = createSelector([getUIState], (uiState) => uiState.widgetOpens);

const getWidgetOpensChartState = createSelector(
    [getWidgetOpensState],
    (widgetOpens) => widgetOpens.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getWidgetOpensChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getWidgetOpensChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getWidgetOpensChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getWidgetOpensChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);

export const getCurrentReportChartBucketCount = createSelector(
    [getCurrentReportChartData],
    (chartData) => (chartData ? chartData.buckets.length : 1)
);

// Alias for ReportDataSummary compatibility
export const getChartBucketCount = getCurrentReportChartBucketCount;

export const getIsLoading = getCurrentReportChartIsLoading;

export const getSummaryStats = createSelector([getCurrentReportChartData], (chartData) => {
    const defaultStats = {
        opens: {sum: {value: 0, formatted: '0', prefix: '', suffix: ''}},
    } as const;

    if (!chartData || !chartData.reports || !chartData.reports[0] || !chartData.summaries) {
        return defaultStats;
    }

    const reportId = chartData.reports[0].id;
    const summary = chartData.summaries[reportId];

    if (!summary || summary.count === undefined) {
        return defaultStats;
    }

    return {
        opens: {
            sum: {
                value: summary.count,
                formatted: String(summary.count),
                prefix: '',
                suffix: '',
            },
        },
    };
});
